import $ from 'jquery';
import _debounce from 'lodash/debounce';

export default ($subscriptionsByAgeDropdown) => {
    $subscriptionsByAgeDropdown.each((i, el) => {
        const $collection = $(el);
        const $subs = $collection.find('.subscriptions-by-age-interest-sub');
        const $shop = $collection.find('.shop-item-card__container');
        const $filters = $collection.find(
            '#subscriptions-by-age-dropdown__age-filter-menu',
        );

        setDefaultOption();
        $shop.each(function () {
            filterShopItems($(this));
        });
        setCardHeights();

        $filters.change(function () {
            let filtered = true;

            $subs.each(function () {
                filterResultsByAge($(this));
            });

            $shop.each(function () {
                filterShopItems($(this));
            });
            setCardHeights();

            if (filtered) {
                if (!$collection.hasClass('--filtered')) {
                    $collection.addClass('--filtered');
                }
            } else if (!filtered) {
                if ($collection.hasClass('--filtered')) {
                    $collection.removeClass('--filtered');
                }
            }
        });

        $(window).on(
            'resize',
            _debounce(() => {
                setCardHeights();
            }, 100),
        );

        function setDefaultOption() {
            $('select option[value=all]').attr('selected', true);
        }

        function filterShopItems($el) {
            const ageRanges = $el.attr('data-age-ranges');
            const selectedAge = $('select option:selected').val();
            if (ageRanges === selectedAge) {
                $el.show();
            } else {
                $el.hide();
            }
        }

        function filterResultsByAge($el) {
            let filtered = true;
            const ageRanges = $el.attr('data-age-ranges').split(',');
            const selectedAge = $('select option:selected').val();

            if (selectedAge === 'all') {
                filtered = false;
                $el.show();
            } else if (ageRanges.includes(selectedAge)) {
                $el.show();
            } else {
                $el.hide();
            }
            return filtered;
        }

        function setTallestMobileCardHeightForRow() {
            const $shopCards = $('.shop-item-card__container:visible');
            for (let i = 0; i + 1 < $shopCards.length; i += 2) {
                // remove any preset heights from previous screen sizes
                $($shopCards[i]).height('');
                $($shopCards[i + 1]).height('');
                // get true heights
                const firstCardHeight = $($shopCards[i]).height();
                const secondCardHeight = $($shopCards[i + 1]).height();
                if (firstCardHeight > secondCardHeight) {
                    $($shopCards[i + 1]).css('height', firstCardHeight + 'px');
                } else {
                    $($shopCards[i]).css('height', secondCardHeight + 'px');
                }
            }
        }

        function setTallestCardHeightForRow() {
            const $shopCards = $('.shop-item-card__container:visible');
            let maxHeight = 0;
            for (let i = 0; i < $shopCards.length; i++) {
                // remove any preset heights from previous screen sizes
                $($shopCards[i]).height('');
                if ($($shopCards[i]).height() > maxHeight) {
                    maxHeight = $($shopCards[i]).height();
                }
            }
            for (let i = 0; i < $shopCards.length; i++) {
                if ($($shopCards[i]).height() < maxHeight) {
                    $($shopCards[i]).css('height', maxHeight + 'px');
                }
            }
        }

        function setCardHeights() {
            const isMobile = $(window).width() < 768; // tablet to use desktop card layout
            if (isMobile) {
                setTallestMobileCardHeightForRow();
            } else {
                setTallestCardHeightForRow();
            }
        }
    });

    $(window).on('load', (e) => {
        const $emailCapture = $('#email-capture-1');
        if ($emailCapture) {
            $($emailCapture).addClass('gift-guide-2024-email-capture');
        }
    });
};
